module.exports = __webpack_public_path__ + "img/content.ed946a91.svg";